// extracted by mini-css-extract-plugin
export default {"themeSwitch":"theme_themeSwitch__hFt4P","switch":"theme_switch__FDxbO"};